import type { StoreTeam } from "@coworker/types/lib/storeteam";
import { useTeamId, useStoreId } from "../auth/useLoggedInUser";
import { getStoreTeams } from "../../hooks/API/core.service";
import { useQuery } from "@tanstack/react-query";
import { INTERVAL } from "../../constants/clientTime";

export function useStoreTeams() {
  const storeId = useStoreId();
  const result = useQuery<StoreTeam[]>({
    queryKey: ["storeTeams", storeId],
    queryFn: async () => await getStoreTeams(storeId),
    enabled: !!storeId,
    staleTime: 15 * INTERVAL.MINUTE,
    refetchOnWindowFocus: false,
  });
  return (result?.data as StoreTeam[]) ?? [];
}

export function useTeamsByStore(storeId: string | null) {
  const result = useQuery<StoreTeam[]>({
    queryKey: ["storeTeams", storeId],
    queryFn: async () => await getStoreTeams(storeId),
    staleTime: 15 * INTERVAL.MINUTE,
    refetchOnWindowFocus: false,
    enabled: storeId !== null,
  });
  return result;
}

export function useMyTeam() {
  const teamId = useTeamId();
  return useStoreTeams().find((team: StoreTeam) => team.id === teamId);
}
